/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo, useRef, useState } from "react";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "~/db/db";
import useFamiliaProduto from "./useFamiliaProduto";

const usePrazoRegraSimuladores = ({ gruposegmento = 0, familias = [], filters = {} }) => {
  const formikRef = useRef();
  const { familiasProduto } = useFamiliaProduto({ formikRef });

  const [prazoRegras, setPrazoRegra] = useState([]);
  const memoFamilias = useMemo(() => familias || [], [JSON.stringify(familias)]);
  const memoFilters = useMemo(() => filters || {}, [JSON.stringify(filters)]);
  useEffect(() => {
    const fetchPrazoRegra = async () => {
      const result = [];
      await db.prazoRegra.filter((a) => a.ativo).each((item) => result.push(item));

      const filteredResult = result
        .filter((pr) =>
          pr.ativo &&
          (gruposegmento > 0 ? pr.grupoSegmentoId === gruposegmento : true) &&
          (memoFilters?.grupoSegmento ? pr.grupoSegmentoId === memoFilters.grupoSegmento : true)
        )
        .map((prazoRegra) => {
          const agrupamentos = prazoRegra.agrupamento.split(", ");

          const familiasFiltradas = (familiasProduto || []).filter((f) => {
            const matchesId = memoFamilias.length > 0 ? memoFamilias.includes(f.id) : true;
            const matchesGrupoProduto = memoFilters?.grupoProduto ? f.grupoMaterialId === memoFilters.grupoProduto : true;
            return matchesId && matchesGrupoProduto && agrupamentos.includes(f.codigo);
          });

          return familiasFiltradas.length > 0
            ? {
                ...prazoRegra,
                familias: familiasFiltradas,
                agrupamentos,
                gruposMaterial: familiasFiltradas.map((e) => e.grupoMaterialId),
              }
            : null;
        })
        .filter((prazoRegra) => prazoRegra !== null);

      setPrazoRegra(filteredResult);
    };



    fetchPrazoRegra();
  }, [familiasProduto, memoFamilias, memoFilters, gruposegmento]);


  const familiasPrazoDisponiveis = useMemo(() => {
    const result = new Set();
    if (prazoRegras) {
      for (const prazoRegra of prazoRegras) {
        if (prazoRegra?.familias) {
          for (const familia of prazoRegra.familias) {
            result.add(familia.id);
          }
        }
      }
    }
    return Array.from(result);
  }, [prazoRegras]);

  const gruposSegmentoPrazoDisponiveis = useMemo(() => {
    const result = new Set();
    if (prazoRegras) {
      for (const prazoRegra of prazoRegras) {
        if (prazoRegra?.grupoSegmentoId) {
          result.add(prazoRegra?.grupoSegmentoId);
        }
      }
    }
    return Array.from(result);
  }, [prazoRegras]);

  return {
    prazoRegras,
    familiasPrazoDisponiveis,
    gruposSegmentoPrazoDisponiveis,
  };
};


export default usePrazoRegraSimuladores;
